<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
    <path fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M26 6H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3v-6m-18 9v8m-10 0h20m-2-29l5 5l5-5m-5-7v12"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    },
  },
};
</script>
